import {
    App, Typography, Row, Col
} from 'antd';
import { useTranslation } from "react-i18next";
import React, { useState, useEffect } from "react";
import {
    WarningOutlined
} from "@ant-design/icons";
import {showApiError} from "../../utility/error/error-handler";
import {getLocalData} from "../../utility/global-util";
import AlertPanelFrame from '../../components/panels/AlertPanelFrame';
import { getAlerts } from "../../api/vehicle";
import useOnlineStatus from "../../utility/hooks/useOnlineStatus";
import './Home.css';

const { Text } = Typography;

const AlertsPanel = ({vehicle, refreshPage, setRefreshPage}) => {
    const { t } = useTranslation();
    const { notification } = App.useApp();
    const [ alerts, setAlerts] = useState(null);
    const [ alertLevel, setAlertLevel] = useState(null);

    const customerServiceNumber = getLocalData('customerContactNo');
    const coGroupServiceNumber = getLocalData('coGroupContactNo');
    const { isOnline } = useOnlineStatus();
  
    function getAlertHeading(type) {
        if(type === "MOT_EXPIRED") 
        {
            return t('title.mot_expired');
        }
        if(type === "RFL_EXPIRED")  
        {
            return t('title.rfl_expired');
        }
        if(type === "ANCILLARY_TEST_EXPIRED")
        {
            return t('title.ancillary_test_expired');
        }
        if(type === "SERVICE_OVERDUE")  
        {
            return t('title.service_overdue');
        }
        if(type === "ANCILLARY_SERVICE_OVERDUE") 
        {
            return t('title.ancillary_service_overdue');
        }
    }

    function getAlertMessage(type) {
        if(type === "MOT_EXPIRED") 
        {
            return 'message.mot_expired';
        }
        if(type === "RFL_EXPIRED")  
        {
            return 'message.rfl_expired';
        }
        if(type === "ANCILLARY_TEST_EXPIRED")
        {
            return 'message.ancillary_test_expired';
        }
        if(type === "SERVICE_OVERDUE")  
        {
            return 'message.service_overdue';
        }
        if(type === "ANCILLARY_SERVICE_OVERDUE") 
        {
            return 'message.ancillary_service_overdue';
        }
    }

    const AlertCard = (params) => {
        return (<>
          <Row>
             <Col xs={24} sm={24} md={24} lg={24} xl={24}><Text className={"dp-alert-title dp-alert-title-" + alertLevel}>{getAlertHeading(params.type)}</Text></Col>
             <Col xs={24} sm={24} md={24} lg={24} xl={24}><Text>{t(getAlertMessage(params.type), {"0" : (customerServiceNumber ? customerServiceNumber : coGroupServiceNumber)})}</Text></Col>
          </Row>
        </>);
    }

    useEffect(() => {
        if (vehicle)
        {
            getAlerts(vehicle.vehicleId)
                .then(res => {
                    setAlerts(res.alerts);
                    setAlertLevel(res.alertLevel);
                },)
                .catch(err => {
                    // Show error if online otherwise show dash if offline (not been on this vehicle or cache not working)
                    if (isOnline()) {
                        showApiError('', err, notification);
                    }
                });
        }
        setRefreshPage(false);
      }, [t, notification, vehicle, refreshPage, setRefreshPage, isOnline]);

    function getTitle()
    {
        return t('title.vehicle_alert');
    }

    if (alerts)
    {
      return (
        <AlertPanelFrame image={<WarningOutlined />} title={getTitle()} level={alertLevel}>
        {
            alerts.map((alert) => {
                return <AlertCard type={alert}/>
            })
        }
        </AlertPanelFrame>
      );
    }
    else
    {
        return <></>;
    }
}

export default AlertsPanel;
